import howToModPlot from "../../../../content/posts/blogs/2023/how-to-mod/howtomod.jsx";
import * as React from 'react';
export default {
  howToModPlot,
  React
};